import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import useStyles from './LabRequestDetails.styles';
import { selectCurrentLabRequest, loadLabRequestById, selectCurrentError, selectLoading } from '../../state';
import { format, formatDistance } from 'date-fns';
import { useParams } from 'react-router';
import { LabRequest } from '../../../../interfaces/lab-request';
import { AuditTrail } from '../../../../interfaces/audit-trail';

const renderDistance = (labRequest: LabRequest, audit: AuditTrail, index: number) => {
  try {
    return index > 0 ?
      formatDistance(new Date(audit.timestamp), new Date(labRequest.auditTrails[0].timestamp)) + ' later' :
      null
  } catch(e) {
    return '';
  }
}

export default function LabRequestsList() {
  const labRequest = useSelector(selectCurrentLabRequest);
  const error = useSelector(selectCurrentError);
  const loading = useSelector(selectLoading);
  const { id } = useParams<{id: string}>();
  const classes = useStyles();
  const dispatch = useDispatch();
  const stableDispatch = useCallback(dispatch, []);

  useEffect(() => {
    stableDispatch(loadLabRequestById(id));
  }, [stableDispatch, id]);

  if (error) {
    // TODO: implement correctly with retry operation
    return (
      <div className={classes.error}>
        {error}
      </div>
    )
  }

  if (!labRequest || loading) {
    return (
      <div>Loading...</div>
    );
  }

  return (
    <TableContainer className={classes.container} component={Paper}>
      <Table stickyHeader className={classes.table} aria-label="lab requests">
        <TableHead>
          <TableRow>
            <TableCell>Code</TableCell>
            <TableCell align="center">Date</TableCell>
            <TableCell align="center">Description</TableCell>
            <TableCell align="center">Source</TableCell>
            <TableCell align="center">Metadata</TableCell>
            <TableCell align="center"></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {labRequest.auditTrails.map((audit, index) => (
            <TableRow key={audit.id}>
              <TableCell component="th" scope="row">
                {audit.code}
              </TableCell>
              <TableCell align="center">
                {format(new Date(audit.timestamp), 'M/d/yyyy, hh:mm aaa')}
                <br />
                {renderDistance(labRequest, audit, index)}
              </TableCell>
              <TableCell align="center">
                {audit.description}
              </TableCell>
              <TableCell align="center">
                {audit.source}
              </TableCell>
              <TableCell>
                {
                  audit && audit.metadata ?
                    (<div>
                      {Object.keys(audit.metadata)
                        .filter((key) => audit.metadata[key] !== undefined)
                        .map((key) => (<p key={key}>
                          {key}: {audit.metadata[key] === null ? '' : audit.metadata[key].toString()}
                        </p>))}
                    </div>) :
                    null
                }
              </TableCell>
              <TableCell align="center"><br /></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
